import { alert } from "components/Alert"
import { confirm } from "components/Confirmation"
import CustomDropzone from "components/CustomDropzone"
import { useEffect, useState } from "react"
import { Button, Modal, ModalBody } from "reactstrap"

export default function ModalIncluirEvidencia({ config, onClosed }) {
  const [fileAntes, setFileAntes] = useState()
  const [fileDepois, setFileDepois] = useState()

  useEffect(() => {
    setFileAntes()
    setFileDepois()
  }, [config])

  const handleChangeAntes = value => {
    setFileAntes(value)
  }

  const handleChangeDepois = value => {
    setFileDepois(value)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!fileAntes || !fileDepois) {
      alert({
        text: 'Você precisa selecionar uma foto do local antes e um foto do local depois da execução',
      })
      return
    }

    confirm({
      header: "Inclusão",
      text: "Tem certeza que gostaria de continuar?",
      onConfirm: async () => {
        if (config.onFileSelected) {
          await config.onFileSelected(fileAntes, fileDepois)
        }
        onClosed && onClosed()
      }
    })
  }

  return (
    <Modal isOpen={!!config} size="lg">
      <ModalBody>
        <h2>Selecione uma nova foto da área antes e uma foto da área depois da execução</h2>
        <hr />
        <form onSubmit={handleSubmit}>
          <div className="d-flex flex-row gap-5px">
            <div>
              Antes<br />
              <CustomDropzone
                value={fileAntes}
                onChange={value => handleChangeAntes(value)}
                onRemove={() => handleChangeAntes(null)}
                edit={true}
              />
            </div>
            <div>
              Depois<br />
              <CustomDropzone
                value={fileDepois}
                onChange={value => handleChangeDepois(value)}
                onRemove={() => handleChangeDepois(null)}
                edit={true}
              />
            </div>
          </div>
          <div className="text-right mt-4">
            <Button type="submit" color="primary">Salvar</Button>
            <Button type="button" color="primary" outline onClick={onClosed}>Cancelar</Button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}